module.exports = __webpack_public_path__ + "img/th.110924bd.png";